import HomeIcon from '../assets/breadcrumbs/home.webp';

export const photoGalleryBreadcrumbsData = [
  {
    label: <img src={HomeIcon} alt="home" width={16} height={16} />,
    path: '/'
  },
  { label: 'India', path: '/photo-gallery' },
  { label: 'Nort India', path: '/photo-gallery' },
  { label: 'Reviews', path: '/photo-gallery' }
];

export const desktopRows = [{ count: 4 }, { count: 3 }, { count: 4 }, { count: 3 }, { count: 4 }];

export const mobileRows = [
  { count: 2 },
  { count: 2 },
  { count: 1 },
  { count: 2 },
  { count: 2 },
  { count: 1 },
  { count: 2 },
  { count: 2 },
  { count: 1 },
  { count: 1 }
];
